export const QUESTION_TYPES = {
  CLOSED_ENDED: "closed_ended",
  OPEN_ENDED: "open_ended",
  MATRIX: "matrix",
};

export const questionConfig = {
  sections: [
    {
      id: "satisfaction",
      title: "The Satisfaction Topline",
      questions: [
        {
          id: "q1",
          type: QUESTION_TYPES.CLOSED_ENDED,
          title: "Overall, how satisfied are you with your life nowadays?",
          subtitle: "% by response",
          chartType: "bar",
          chartProps: {
            height: 220,
            width: 600,
          },
          gridProps: {
            colSpan: 12,
          },
        },
      ],
    },
    {
      id: "wellbeing",
      title: "Personal Wellbeing",
      questions: [
        {
          id: "q2",
          type: QUESTION_TYPES.OPEN_ENDED,
          title: "What is going well in your life?",
          chartType: "treemap",
          gridProps: {
            colSpan: 12,
          },
        },
        {
          id: "q3",
          type: QUESTION_TYPES.OPEN_ENDED,
          title: "What is currently causing you the most stress?",
          chartType: "treemap",
          gridProps: {
            colSpan: 12,
          },
        },
        {
          id: "q4",
          type: QUESTION_TYPES.OPEN_ENDED,
          title: "What in your life makes you feel hopeful about your future?",
          chartType: "treemap",
          gridProps: {
            colSpan: 12,
          },
        },
        {
          id: "q5",
          type: QUESTION_TYPES.OPEN_ENDED,
          title:
            "Thinking about groups, organizations, or networks you're a part of. Which ones give you a strong sense of belonging, and why?",
          chartType: "treemap",
          gridProps: {
            colSpan: 12,
          },
        },
      ],
    },
    {
      id: "community",
      title: "Community Wellbeing",
      questions: [
        {
          id: "q6",
          type: QUESTION_TYPES.CLOSED_ENDED,
          title:
            "Compared to other people in your local community, how do you rate your overall quality of life?",
          chartType: "bar",
          chartProps: {
            height: 220,
            width: 600,
          },
          gridProps: {
            colSpan: 12,
          },
        },
      ],
    },
    {
      id: "action",
      title: "Taking Action",
      questions: [
        {
          id: "q11_matrix",
          type: QUESTION_TYPES.MATRIX,
          questionIds: [
            "q11_1",
            "q11_2",
            "q11_3",
            "q11_4",
            "q11_5",
            "q11_6",
            "q11_7",
            "q11_8",
            "q11_9",
            "q11_10",
          ],
          title:
            "Consider the following issues. How much impact do you believe your actions and participation can have on each?",
          categories: [
            "Strong impact",
            "Moderate impact",
            "Slight impact",
            "Very little impact",
            "Zero impact",
          ],
          rowLabels: [
            "Economy and Income",
            "Housing Affordability",
            "Abortion and Reproductive Rights",
            "Healthcare",
            "Public K-12 Education",
            "Climate Change",
            "Immigration",
            "Gun Rights and Gun Control",
            "Voting Rights and Election Integrity",
            "Worker Rights and Unions",
          ],
          chartType: "horizontal_stacked_bar",
          chartProps: {
            height: 750,
            width: 900,
            legendHeight: 100,
            colors: ["#2ca25f", "#99d8c9", "#BBBBBB", "#ff9896", "#d62728"],
          },
          gridProps: {
            colSpan: 12,
          },
        },
        {
          id: "q12_matrix",
          type: QUESTION_TYPES.MATRIX,
          questionIds: [
            "q12_1",
            "q12_2",
            "q12_3",
            "q12_4",
            "q12_5",
            "q12_6",
            "q12_7",
            "q12_8",
            "q12_9",
            "q12_10",
          ],
          title:
            "Consider the following issues. How effective or ineffective do you feel the government is in addressing each?",
          categories: [
            "Very effective",
            "Effective",
            "Ineffective",
            "Very ineffective",
            "Neither effective nor ineffective",
          ],
          rowLabels: [
            "Economy and Income",
            "Housing Affordability",
            "Abortion and Reproductive Rights",
            "Healthcare",
            "Public K-12 Education",
            "Climate Change",
            "Immigration",
            "Gun Rights and Gun Control",
            "Voting Rights and Election Integrity",
            "Worker Rights and Unions",
          ],
          chartType: "horizontal_stacked_bar",
          chartProps: {
            height: 750,
            width: 900,
            legendHeight: 100,
            colors: ["#2ca25f", "#99d8c9", "#BBBBBB", "#ff9896", "#d62728"],
          },
          gridProps: {
            colSpan: 12,
          },
        },
      ],
    },
    {
      id: "issues",
      title: "Issues",
      questions: [
        {
          id: "q13",
          type: QUESTION_TYPES.CLOSED_ENDED,
          title: "How informed do you feel about local political issues?",
          chartType: "bar",
          chartProps: {
            height: 220,
            width: 600,
          },
          gridProps: {
            colSpan: 12,
          },
        },
        {
          id: "q15",
          type: QUESTION_TYPES.CLOSED_ENDED,
          title:
            "How confident are you in the fairness of the electoral process?",
          chartType: "bar",
          chartProps: {
            height: 220,
            width: 600,
          },
          gridProps: {
            colSpan: 12,
          },
        },
        {
          id: "q16",
          type: QUESTION_TYPES.CLOSED_ENDED,
          title:
            "How concerned are you about climate change and its impact on your local community?",
          chartType: "bar",
          chartProps: {
            height: 220,
            width: 600,
          },
          gridProps: {
            colSpan: 12,
          },
        },
        {
          id: "q17",
          type: QUESTION_TYPES.CLOSED_ENDED,
          title:
            "How would you rate the overall quality of public K-12 education provided by your local schools?",
          chartType: "bar",
          chartProps: {
            height: 220,
            width: 600,
          },
          gridProps: {
            colSpan: 12,
          },
        },
        {
          id: "q18",
          type: QUESTION_TYPES.CLOSED_ENDED,
          title:
            "Which of the following statements comes closest to your view on the laws concerning the ownership and use of guns?",
          chartType: "bar",
          chartProps: {
            height: 220,
            width: 600,
          },
          gridProps: {
            colSpan: 12,
          },
        },
        {
          id: "q19",
          type: QUESTION_TYPES.CLOSED_ENDED,
          title: "Which statement is closer to your view on recent immigrants?",
          chartType: "bar",
          chartProps: {
            height: 220,
            width: 600,
          },
          gridProps: {
            colSpan: 12,
          },
        },
        {
          id: "q20",
          type: QUESTION_TYPES.CLOSED_ENDED,
          title: "Which statement is closest to your view on abortion?",
          chartType: "bar",
          chartProps: {
            height: 220,
            width: 600,
          },
          gridProps: {
            colSpan: 12,
          },
        },
      ],
    },
  ],
};

// Helper function to get all open-ended questions
export const getOpenEndedQuestions = () => {
  return questionConfig.sections
    .flatMap((section) => section.questions)
    .filter((question) => question.type === QUESTION_TYPES.OPEN_ENDED);
};

// Helper function to get all closed-ended questions
export const getClosedEndedQuestions = () => {
  return questionConfig.sections
    .flatMap((section) => section.questions)
    .filter((question) => question.type === QUESTION_TYPES.CLOSED_ENDED);
};

// Helper function to get a question by ID
export const getQuestionById = (questionId) => {
  return questionConfig.sections
    .flatMap((section) => section.questions)
    .find((question) => question.id === questionId);
};

// Helper function to get a section by ID
export const getSectionById = (sectionId) => {
  return questionConfig.sections.find((section) => section.id === sectionId);
};
